import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

export const CurrentVersion = async (option) => {
  const response = await $api.get(Endpoints.Setting.CurrentVersion(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Yeni satışlar için tenant varsayılan borç oluşturma modunu getirir.
 * @returns {{ message: string, data?: { debtCreationMode: "Automatic" | "Manual" } }}
 */
export const GetSaleDebtCreationMode = async (option) => {
  const response = await $api.get(
    Endpoints.Setting.SaleDebtCreationMode(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Tenant varsayılan borç oluşturma modunu günceller (Admin).
 * @param {{ debtCreationMode: "Automatic" | "Manual" }} form
 */
export const UpdateSaleDebtCreationMode = async (form) => {
  const response = await $api.put(
    Endpoints.Setting.SaleDebtCreationMode({ params: {}, query: {} }),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Tenant lead aktarım tipini getirir.
 * @returns {{ message: string, data?: { leadTransferType: "AUTO" | "MANUAL" } }}
 */
export const GetLeadTransferType = async (option) => {
  const response = await $api.get(Endpoints.Setting.LeadTransferType(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * Tenant lead aktarım tipini günceller (CRM Management).
 * @param {{ leadTransferType: "AUTO" | "MANUAL" }} form
 */
export const UpdateLeadTransferType = async (form) => {
  const response = await $api.put(
    Endpoints.Setting.LeadTransferType({ params: {}, query: {} }),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

export default {
  CurrentVersion,
  GetSaleDebtCreationMode,
  UpdateSaleDebtCreationMode,
  GetLeadTransferType,
  UpdateLeadTransferType,
};
